/**
 * Created by bootdo.
 * 数据导入 api
 */
import * as API from '../'
import $const from '../../common/constant'

export default {

  /**
   * 查询导入状态
   * @param params
   * @returns {Promise<*>}
   */
  queryStatus: params => {
    return API.POST($const.apiServer.Tranning + '/dataImport/queryStatus', params);
  },

  /**
   * 获取导入企业列表（待状态）
   * @param params
   * @returns {Promise<*>}
   */
  improtEnterprises: params => {
    return API.GET($const.apiServer.Tranning + '/dataImport/improt-enterprises', params);
  },

  /**
   * 查询公司列表
   * @param params
   * @returns {Promise<*>}
   */
  importEnterprisebaseTreeRepeated: params => {
    return API.GET($const.apiServer.Tranning + '/dataImport/improt-enterprises-repeated', params);
  },
  improtEnterprisesRepe: params => {
    return API.GET($const.apiServer.Tranning + '/dataImport/improt-enterprises-repe', params);
  },
}




// WEBPACK FOOTER //
// ./src/api/training/api_data_import.js